<template>
	<div class="avatar">
		<a-avatar v-if="url" :size="size" :src="filePreview(url)" />
		<a-avatar v-else-if="name" :size="size" class="avatar-name">{{ name.charAt(0) }}</a-avatar>
		<a-avatar v-else :size="size" />
	</div>
</template>

<script>
export default {
	name: "AbsAvatar",
	props: {
		url: {
			type: String,
			required: false
		},
		name: {
			type: String,
			required: false
		},
    size: {
      type: Number,
      default: 40
    },
	}
}
</script>

<style scoped lang="less">
.avatar-name{
  color: #fff;
  background: #3e7dff
}
</style>
